import axios from 'axios';
import { apiUrl } from '../Config';


const getAuthToken = () => {
    return (
        localStorage.getItem('token') || localStorage.getItem('authToken')
    );
}
export const getProfile = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/employee/profile`, {
            headers: { 'Authorization': `Bearer ${token}` },
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const updateProfile = async (data) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(`${apiUrl}/employee/update`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error(error);    throw error;
    }
}

export const sendEmailOtpApi = async (email) => {
    try {
        const token = getAuthToken();
        const response = await axios.post(`${apiUrl}/employee/send-email-verification`, { email }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error(error);    throw error;
    }
}

export const verifyEmailOtpApi = async (email, otp) => {
    try {
        const token = getAuthToken();
        const response = await axios.post(`${apiUrl}/employee/confirm-email-verification`, { email, otp }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error(error);    throw error;
    }
}

export const sendMobileOtpApi = async (mobile) => {
    try {
        const token = getAuthToken();
        const response = await axios.post(`${apiUrl}/employee/send-mobile-verification`, { mobile }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error(error);    throw error;
    }
}

export const verifyMobileOtpApi = async (mobile, otp) => {
    try {
        const token = getAuthToken();
        const response = await axios.post(`${apiUrl}/employee/confirm-mobile-verification`, { mobile, otp }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error(error);    throw error;
    }
}

export const getSupportContact = async () => {
    try {
        const response = await axios.get(`${apiUrl}/support-contact/list`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}